import {create} from "zustand";
import { persist } from 'zustand/middleware'
import { SalesWrap } from "../api/order/generated/src";


interface ISelectedData {
    id: string,
    subId: string,
}

interface ISelectedArticle {
    article: ISelectedData,    
    updateSelected: (newId: string, newSubId: string) => void
}

export const useSelectedArticleStore = create<ISelectedArticle>((set) => ({
    article: {
        id: "",
        subId: ""
    },
    
    updateSelected: (newId: string, newSubId: string) => set({ 
        article: {
            id: newId ?? "",
            subId: newSubId ?? ""
        }
    })
}));


interface IActiveSalesWrap {
    salesWrap: SalesWrap,
    updateActive: (newSalesWrap: SalesWrap) => void
}

export const useActiveSalesWrapStore = create<IActiveSalesWrap>((set) => ({
    salesWrap: {
       
    },
    
    updateActive: (newSalesWrap: SalesWrap) => set({ 
        salesWrap: {...newSalesWrap}
    })
}));